/**
 * KioskGuard — route guard that locks the app in kiosk mode (ADR-073 Decision 5).
 *
 * When kiosk mode is active, this component replaces the normal SMS layout
 * with the kiosk check-in flow. All navigation attempts are redirected
 * to the kiosk routes.
 */
import { Navigate } from 'react-router-dom';
import { useKiosk } from '../../contexts/KioskContext';

interface KioskGuardProps {
  /** Normal SMS layout (shown when not in kiosk mode) */
  children: React.ReactNode;
}

/**
 * Wraps the authenticated layout. If kiosk mode is active, redirects to
 * the kiosk check-in flow instead of rendering the normal SMS UI.
 */
export function KioskGuard({ children }: KioskGuardProps) {
  const { isKioskMode } = useKiosk();

  if (isKioskMode) {
    return <Navigate to="/kiosk" replace />;
  }

  return <>{children}</>;
}
